module.exports = __webpack_public_path__ + "img/Responsible Citizen.10a5937c.svg";